export default "__VITE_ASSET__CNUXqzTU__"